import 'css-chunksrc/client/pages/zonePage/styles.scss';export default {
  "zonePage": "_zonePage_1slyj_1",
  "header": "_header_1slyj_9",
  "zone": "_zone_1slyj_1",
  "backButton": "_backButton_1slyj_24",
  "zonesIcon": "_zonesIcon_1slyj_34",
  "separatorArrow": "_separatorArrow_1slyj_44",
  "subHeader": "_subHeader_1slyj_53",
  "menu": "_menu_1slyj_60",
  "profileNavigation": "_profileNavigation_1slyj_67",
  "filterForm": "_filterForm_1slyj_78",
  "main": "_main_1slyj_86"
};